import { ServerSendEvent } from "@/models"

export const configureServerSentEvent = () => new ServerSendEvent()
